import svgUrl from "ni:svgr;x-vdHdEaVMuEIOGS_nzYlsPZ4V4G6CCDoefyUuPfa6g";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgRef = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 4v1a3 3 0 0 0 3 3h8m0 0-4-4m4 4-4 4" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const Memo = memo(SvgRef);
export { Memo as ReactComponent };